/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {BoundingBox as RenderBoundingBox} from "js_renderer";
import {mat4, vec3} from "gl-matrix";
import IBoundingBox from "./bounding_box_interface";

/***
 * Wrapper for cadwork.webgl.utils.BoundingBox for usage in the application
 * @constructor
 */
export default
class BoundingBox implements IBoundingBox {
    private _bbox: RenderBoundingBox;

    constructor() {
        this._bbox = new RenderBoundingBox();
    }

    public set(aBBox: RenderBoundingBox) {
        this._bbox = aBBox.clone();
    }

    public extend(aSceneAPIBBox: IBoundingBox) {
        //@ts-ignore
        this._bbox.extendByBBox(aSceneAPIBBox._bbox);
    }

    public getDiameter(): number {
        return this._bbox.getDiameter();
    }

    public getRadius(): number {
        return this._bbox.getRadius();
    }

    public getCenter(): vec3 {
        return vec3.clone(this._bbox.getCenter());
    }

    public getDimensions(): vec3 {
        return this._bbox.getDimensions();
    }

    public getMin(): vec3 {
        return vec3.clone(this._bbox.getMin());
    }

    public getMax(): vec3 {
        return vec3.clone(this._bbox.getMax());
    }

    public isValid(): boolean {
        return this._bbox.isValid();
    }

    public transformMat4(aTransformation: mat4) {
        return this._bbox.transformMat4(aTransformation);
    }
}
